import { ShoppingBagIcon, TagIcon } from 'lucide-react';

import type { SkuDTO } from '@invenco/products-interface';

import { DialogTrigger } from '@/components/core/dialog';
import { DetailEditButton, DetailList } from '@/components/detail-list';
import { FormDialog } from '@/components/forms/form-dialog';
import { formatMoney } from '@/shared/helpers';
import type { Result } from '@/shared/helpers/Result';

import { PricesDialogContent } from './prices-dialog-content';

type Props = {
  sku?: Partial<SkuDTO>;
  isLoading?: boolean;
  onSubmit: (data: Partial<SkuDTO>) => Promise<Result> | Promise<void> | void;
};

export function PricesSection({ sku, isLoading, onSubmit }: Props) {
  return (
    <FormDialog>
      <DetailList
        title="Prices"
        isLoading={isLoading}
        action={
          <DialogTrigger asChild>
            <DetailEditButton disabled={isLoading} />
          </DialogTrigger>
        }
        items={[
          {
            icon: ShoppingBagIcon,
            label: 'Purchase',
            value:
              sku?.purchasePrice !== undefined && sku.purchasePrice !== null
                ? formatMoney(sku.purchasePrice)
                : undefined,
          },
          {
            icon: TagIcon,
            label: 'Sell',
            value:
              sku?.sellPrice !== undefined && sku.sellPrice !== null
                ? formatMoney(sku.sellPrice)
                : undefined,
          },
        ]}
      />
      <PricesDialogContent sku={sku} onSubmit={onSubmit} />
    </FormDialog>
  );
}
